var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useState, useMemo } from 'react';
import { isArray } from '../_util/is';
var useCheckbox = function (values, defaultSelected) {
    var _a = useState(__spreadArrays(defaultSelected)), selected = _a[0], setSelected = _a[1];
    var _b = useMemo(function () {
        // 判断是否选中
        var isSelected = function (value) {
            return selected.indexOf(value) > -1;
        };
        // 设置选中
        var setValueSelected = function (value, selectStatus) {
            var list = isArray(value) ? value : [value];
            var newSelected;
            if (selectStatus) {
                newSelected = __spreadArrays(selected, list);
            }
            else {
                newSelected = selected.filter(function (x) { return list.indexOf(x) === -1; });
            }
            setSelected(Array.from(new Set(newSelected)));
        };
        return {
            isSelected: isSelected,
            setValueSelected: setValueSelected,
        };
    }, [selected]), isSelected = _b.isSelected, setValueSelected = _b.setValueSelected;
    var _c = useMemo(function () {
        var selectAll = function () {
            setSelected(values);
        };
        var unSelectAll = function () {
            setSelected([]);
        };
        var toggle = function (value) {
            if (value === void 0) { value = values; }
            var list = isArray(value) ? value : [value];
            var newSelected = __spreadArrays(selected);
            list.forEach(function (x) {
                var index = newSelected.indexOf(x);
                if (index > -1) {
                    newSelected.splice(index, 1);
                }
                else {
                    newSelected.push(x);
                }
            });
            setSelected(newSelected);
        };
        var isAllSelected = function () {
            return values.every(function (x) { return isSelected(x); });
        };
        /**
         * 是否部分选中
         */
        var isPartialSelected = function () {
            return values.some(function (x) { return isSelected(x); }) && !isAllSelected();
        };
        return {
            selectAll: selectAll,
            unSelectAll: unSelectAll,
            toggle: toggle,
            isAllSelected: isAllSelected,
            isPartialSelected: isPartialSelected,
        };
    }, [selected, values]), selectAll = _c.selectAll, unSelectAll = _c.unSelectAll, toggle = _c.toggle, isAllSelected = _c.isAllSelected, isPartialSelected = _c.isPartialSelected;
    return {
        selected: selected,
        setSelected: setSelected,
        setValueSelected: setValueSelected,
        selectAll: selectAll,
        unSelectAll: unSelectAll,
        toggle: toggle,
        isSelected: isSelected,
        isAllSelected: isAllSelected,
        isPartialSelected: isPartialSelected,
    };
};
export default useCheckbox;
